import $ from "jquery";

const Accordion = () => {
  if (document.getElementsByClassName("accordion").length > 0) {
    const transcriptContainer = document.querySelectorAll(".transcript");
    const anchorContainer = document.querySelectorAll(".toggle-accordion");

    const toggleAccordion = () => {
      const anchorList = [].slice.call(anchorContainer);
      anchorList.forEach(el => {
        const transcript = $(el).next();
        const accordionEvent = () => {
          if (!$(el).hasClass("open")) {
            $(el).addClass("open");
            $(el).removeClass("closed");
            transcript.attr("aria-hidden", "false");
            $(el)
              .parent()
              .removeClass("accordion-closed");
            $(el)
              .parent()
              .addClass("accordion-active");
            $(el).attr("aria-expanded", "true");
          } else {
            $(el).addClass("closed");
            $(el).removeClass("open");
            transcript.attr("aria-hidden", "true");
            $(el)
              .parent()
              .removeClass("accordion-active");
            $(el)
              .parent()
              .addClass("accordion-closed");
            $(el).attr("aria-expanded", "false");
          }
        };

        el.addEventListener("click", () => {
          accordionEvent();
        });

        el.addEventListener("keyup", e => {
          if (e.keyCode === 13 || (e.keyCode === 32 && $(el).is(":focus"))) {
            accordionEvent();
          }
        });
      });
    };

    const toggleHeight = () => {
      const transcriptHeight = [].slice.call(transcriptContainer);
      transcriptHeight.forEach(el => {
        const element = el;
        const height = `${-(el.clientHeight * 2)}px`;
        element.style.top = height;
      });
    };

    const init = () => {
      toggleHeight();
      toggleAccordion();
    };

    init();
  }
};

export default Accordion;
